import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer-new.css";
import logo from "../../../assets/images/logo.png";
import {
  FaFacebookF,
  FaXTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa6";

function Footer() {
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    setEmail("");
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section company-info">
            <div className="footer-logo">
              <img src={logo} alt="GoalFlex" />
              <span>GoalFlex</span>
            </div>
            <p className="footer-description">
              Connecting soccer players across Minnesota and building inclusive
              communities where players of all skill levels can find games and
              grow together through the beautiful game.
            </p>
            <div className="footer-stats">
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Active Players</span>
              </div>
              <div className="stat">
                <span className="stat-number">Minnesota</span>
                <span className="stat-label">Service Area</span>
              </div>
              <div className="stat">
                <span className="stat-number">25+</span>
                <span className="stat-label">Weekly Games</span>
              </div>
            </div>
          </div>

          {/* Platform Links */}
          <div className="footer-section">
            <h4>Platform</h4>
            <ul>
              <li>
                <Link to="/how-it-works">How It Works</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/download">Download App</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
            </ul>
          </div>

          {/* Community Links */}
          <div className="footer-section">
            <h4>Community</h4>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/partnerships">Partnerships</Link>
              </li>
              <li>
                <Link to="/press-media">Press & Media</Link>
              </li>
              <li>
                <Link to="/help-center">Help Center</Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service">Terms of Service</Link>
              </li>
              <li>
                <Link to="/delete-account">Delete Account</Link>
              </li>
              <li>
                <Link to="/legal-inquiries">Legal Inquiries</Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-section newsletter">
            <h4>Stay in the Game</h4>
            <p>
              Get the latest updates, game notifications, and soccer tips
              delivered to your inbox.
            </p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                  </svg>
                </button>
              </div>
              <p className="newsletter-disclaimer">
                No spam, unsubscribe anytime
              </p>
            </form>

            {/* Social Links */}
            <div className="social-section">
              <h5>Follow Us @goalflexapp</h5>
              <div className="social-links">
                <div className="social-links">
                  <a
                    href="https://facebook.com/goalflexapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow @goalflexapp on Facebook"
                    className="social-link facebook"
                    title="@goalflexapp on Facebook"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    href="https://twitter.com/goalflexapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow @goalflexapp on X"
                    className="social-link twitter"
                    title="@goalflexapp on X"
                  >
                    <FaXTwitter />
                  </a>

                  <a
                    href="https://instagram.com/goalflexapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow @goalflexapp on Instagram"
                    className="social-link instagram"
                    title="@goalflexapp on Instagram"
                  >
                    <FaInstagram />
                  </a>

                  <a
                    href="https://linkedin.com/company/goalflexapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow GoalFlex on LinkedIn"
                    className="social-link linkedin"
                    title="GoalFlex on LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>

                  <a
                    href="https://tiktok.com/@goalflexapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow @goalflexapp on TikTok"
                    className="social-link tiktok"
                    title="@goalflexapp on TikTok"
                  >
                    <FaTiktok />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <p>
              &copy; {new Date().getFullYear()} GoalFlex, Inc. All rights
              reserved.
            </p>
            <p className="tagline">
              Made with ⚽ for soccer players everywhere
            </p>
          </div>

          <div className="app-download">
            <span>Download the GoalFlex App:</span>
            <div className="app-badges">
              <a
                href="https://apps.apple.com/us/app/goalflex/id6745612755"
                target="_blank"
                rel="noopener noreferrer"
                className="app-badge"
              >
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on App Store"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.goalflex.app&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="app-badge"
              >
                <img
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  alt="Get it on Google Play"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
